import { IPartyPerson } from '../../ui-toolkit/orders/interfaces/IPartyPerson';
import { ePartyType } from '../../ui-toolkit/enums/ePartyType';
import { IPartySignatory } from '../../ui-toolkit/orders/interfaces/IPartySignatory';

export interface ISignerFormData {
  id?: string;
  personId?: string;
  signatoryId?: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  email?: string;
  phoneNumber?: string;
}

const isPartyPerson = (signerParty: IPartyPerson | IPartySignatory): signerParty is IPartyPerson => {
  return 'type' in signerParty && signerParty.type === ePartyType.person;
};

export const covertPartyPersonToSignerFormData = (signerParty: IPartyPerson | IPartySignatory): ISignerFormData => {
  if (isPartyPerson(signerParty)) {
    return {
      id: signerParty.id,
      personId: signerParty.id,
      firstName: signerParty.first_name,
      middleName: signerParty.middle_name,
      lastName: signerParty.last_name,
      email: signerParty.email,
      phoneNumber: signerParty.phone_number,
    };
  }
  return {
    id: signerParty.id,
    signatoryId: signerParty.id,
    firstName: signerParty.firstName,
    middleName: signerParty.middleName,
    lastName: signerParty.lastName,
    email: signerParty.email,
    phoneNumber: signerParty.phoneNumber,
  };
};
